import { SelectedIndicator, useCompare } from '@iheartjane/menu';

interface CompareDotProps {
  focusCardMenu: () => void;
  onToggle: () => void;
  productId: number;
  productName: string;
}

export const CompareDot = ({
  focusCardMenu,
  onToggle,
  productId,
  productName,
}: CompareDotProps) => {
  const { isSelected } = useCompare();

  return (
    <SelectedIndicator
      isSelected={isSelected(productId)}
      onToggle={() => {
        onToggle();
        focusCardMenu();
      }}
      productName={productName}
    />
  );
};
